import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ListVision from './ListVision'

import EditVision from './EditVision'
import NewVision from './NewVision'

const SpecialistVisionRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListVision /></PrivateRoute7>} />
        <Route path="edit-vision" element={<PrivateRoute7><EditVision /></PrivateRoute7>} />
        <Route path="new-vision" element={<PrivateRoute7><NewVision /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistVisionRoutes